import { render } from "./QRScanner.vue?vue&type=template&id=52f1f9ae&scoped=true"
import script from "./QRScanner.vue?vue&type=script&lang=js"
export * from "./QRScanner.vue?vue&type=script&lang=js"

import "./QRScanner.vue?vue&type=style&index=0&id=52f1f9ae&scoped=true&lang=css"

import exportComponent from "/Users/aml/Projects/dashboardcopy2/fnbxv21-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52f1f9ae"]])

export default __exports__